import React, { useState } from 'react'
import { SModalContainer, SModalAddress, SCopyIcon, SDivider, SAddressText } from './styles'
import { CgCopy } from 'react-icons/cg'

const BuyMeACoffePopup = () => {
	const [copied, setCopied] = useState('')

	const handleCopy = (address: string) => {
		navigator.clipboard.writeText(address)
		setCopied(address)
		setTimeout(() => setCopied(''), 2000)
	}

	return (
		<SModalContainer>
			<p>
				Thank you for exploring THORCharts! If you found our insights valuable, please consider supporting us with a donation. We’re a dedicated project without any funding, and your support keeps us
				going!
			</p>
			<SModalAddress>
				<SAddressText>THORChain Address: thor1epz4l9jat4uqrag5j9d5aqrawrn0uhvdfxyxec</SAddressText>
				<SCopyIcon>
					<CgCopy aria-label="Copy THORChain address" onClick={() => handleCopy('thor1epz4l9jat4uqrag5j9d5aqrawrn0uhvdfxyxec')} />
					{copied === 'thor1epz4l9jat4uqrag5j9d5aqrawrn0uhvdfxyxec' && <span style={{ fontSize: '12px' }}>Copied!</span>}
				</SCopyIcon>
			</SModalAddress>
			<SDivider />
			<SModalAddress>
				<SAddressText>Ethereum Address: 0x0A7814810CFE896E2Dd4FEFc0229f4BcED1c2acE</SAddressText>
				<SCopyIcon>
					<CgCopy aria-label="Copy Ethereum address" onClick={() => handleCopy('0x0A7814810CFE896E2Dd4FEFc0229f4BcED1c2acE')} />
					{copied === '0x0A7814810CFE896E2Dd4FEFc0229f4BcED1c2acE' && <span style={{ fontSize: '12px' }}>Copied!</span>}
				</SCopyIcon>
			</SModalAddress>
		</SModalContainer>
	)
}
export default BuyMeACoffePopup
